const DEFAULT_CATEGORY_COLOR = '#666666';

const CATEGORY_COLORS: Record<string, string> = {
  Autre: DEFAULT_CATEGORY_COLOR,
  'Private Equity': '#3C5C8E',
  'Produit Structure': '#9AB6BE',
  'Fonds en euros': '#734E61',
  'Fonds Croissance': '#CE6F8F',
  Immobiliers: '#6B4226',
  SC: '#2C1407',
  OPCI: '#57290E',
  SCP: '#8A5C41',
  SCPI: '#C5ADA0',
  SCI: '#E2D6CF',
  OPCVM: '#4C6641',
  ETF: '#89997D',
  Actions: '#BDCFAF',
};

// Alias connus vers les libellés canoniques (constantes PART_* côté backend) : uniquement de la casse,
// des accents ou un singulier/pluriel différent du même libellé — jamais un regroupement entre
// catégories distinctes.
const CATEGORY_ALIASES: Record<string, string> = {
  'private equity': 'Private Equity',
  'produit structure': 'Produit Structure',
  'fonds euro': 'Fonds en euros',
  'fonds euros': 'Fonds en euros',
  'fonds en euro': 'Fonds en euros',
  'fonds croissance': 'Fonds Croissance',
  action: 'Actions',
  immobilier: 'Immobiliers',
  'produits structures': 'Produit Structure',
  autres: 'Autre',
};

const normalizeAliasKey = (value: string): string =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();

// Permet de faire matcher un libell\u00e9 d\u00e9j\u00e0 canonique quelle que soit sa casse d'origine
// (ex: "fonds en euros" re\u00e7u tel quel doit r\u00e9soudre vers "Fonds en euros"), sans avoir \u00e0
// dupliquer chaque libell\u00e9 de CATEGORY_COLORS dans CATEGORY_ALIASES.
const CANONICAL_LABEL_BY_KEY: Record<string, string> = Object.fromEntries(
  Object.keys(CATEGORY_COLORS).map((label) => [normalizeAliasKey(label), label])
);

const normalizeCategoryLabel = (rawName: string | null | undefined): string => {
  const trimmed = rawName?.trim();
  if (!trimmed) return 'Autre';
  const key = normalizeAliasKey(trimmed);
  return CATEGORY_ALIASES[key] ?? CANONICAL_LABEL_BY_KEY[key] ?? trimmed;
};

const getCategoryColor = (sousTypeFonds: string | null | undefined): string =>
  CATEGORY_COLORS[normalizeCategoryLabel(sousTypeFonds)] ?? DEFAULT_CATEGORY_COLOR;

export { CATEGORY_ALIASES, CATEGORY_COLORS, DEFAULT_CATEGORY_COLOR, getCategoryColor, normalizeCategoryLabel };
